import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { isActionType } from "../../../redux/action.functions";
import * as actions from "./products.actions";
import { ProductsActions } from "./products.actions";
import * as productsService from "../services/products.service";
import { of } from "rxjs";

const search: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(ProductsActions.Search)),
    map((action) => action.payload),
    mergeMap((term) =>
      productsService.searchProducts(term).pipe(
        map((results) => actions.searchSuccess(results)),
        catchError((error) => of(actions.searchFailure(error)))
      )
    )
  );

export const ProductsEffects = [search];
